Vue.component('mailmodal', {
    template: `
        <div>
            <div class="modal fade mailModal" tabindex="-1" role="dialog" ref="mailModal">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">{{ $language.shareFamily }}</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-5">
                                        {{ $language.copyLink }}:
                                        <div class="input-group">
                                            <input type="text" v-model="shareLink" ref="copyInput" class="form-control">
                                            <div class="input-group-append" @click="copyLink" >
                                                <a class="input-group-text" data-toggle="tooltip" :title="$language.clickCopy" ref="copyBtn">
                                                    <i class="fas fa-copy"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-7">
                                        {{ $language.sendFamily }}:

                                        <div class="row">
                                            <div class="col">
                                                <input :class="{'is-invalid':errors.hasOwnProperty('email')}" type="mail" class="form-control" :placeholder="$language.toEmail" v-model="to" name="mailTo">
                                                <div class="invalid-feedback">
                                                    {{ mailError }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col">
                                                <textarea class="form-control" rows="5" :placeholder="$language.optinal" v-model="message"></textarea>
                                            </div>
                                        </div>
                                        <div class="row mailSend">
                                            <div class="col-4">
                                                <button @click="sendMail" class="btn btn-primary" type="button" v-if="!sending">
                                                    {{ $language.send }}
                                                </button>
                                                <button class="btn btn-primary disabled" type="button" v-else>
                                                    <i class="fas fa-spinner fa-spin"></i>
                                                </button>
                                            </div>
                                            <div class="col-8 success text-right" :class="{'show':showSuccess}" v-text="$language.sendSuccess.replace('[EMAIL]', to)">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,
    data: function() {
        return {
            message: '',
            to: '',
            errors: [],
            showSuccess: false,
            sending: false
        };
    },


    computed: {

        shareLink() {

            if (this.$requestedLanguage == 'en') {
                return this.$url + '#/' + this.family;
            } else {
                return this.$url + '?lang=' + this.$requestedLanguage + '#/' + this.family;
            }

        },

        mailError() {
            if (this.errors.email == 'invalid') {
                return this.$language.mailInvalid;
            } else if (this.errors.email == 'required') {
                return this.$language.mailRequired;
            }
        },

        family() {
            return this.$route.params.family;
        }

    },
    watch: {

        to(newMail, oldMail) {
            this.showSuccess = false;
        }

    },

    mounted() {

        EventBus.$on('showShare', () => {
            this.showMailModal();
        });

        $(this.$refs.copyBtn).tooltip();

    },

    methods: {

        showMailModal() {
            $(this.$refs.mailModal).modal('toggle');
        },

        copyLink() {

            let copy = this.$refs.copyInput;
            copy.select();

            document.execCommand("copy");

            $(this.$refs.copyBtn)
                .tooltip('hide')
                .attr('data-original-title', this.$language.copied)
                .tooltip('show');

            setTimeout(() => {
                $(this.$refs.copyBtn)
                    .attr('data-original-title', this.$language.clickCopy);
            }, 1000);
        },

        sendMail() {

            this.errors = [];
            this.showSuccess = false;
            this.sending = true;

            var params = new URLSearchParams();
            params.append('to', this.to);
            params.append('message', this.message);
            params.append('link', this.shareLink);
            params.append('family', this.family);

            axios.post('?page=sendMail&action=send', params)
                .then(res => {
                    this.showSuccess = true;
                    this.sending = false;

                })
                .catch(err => {
                    this.errors = err.response.data;
                    this.sending = false;

                })

        }

    }
});
